module.exports = __webpack_public_path__ + "static/media/average.8d4bf817.svg";